/**
 * Vehicle detail page analytics (Milestone 8 / M15).
 */
import { trackBuyerEvent } from "../buyerAnalytics";
import { toListingAnalyticsPayload } from "./listingViewModels";

export const VEHICLE_DETAIL_ANALYTICS_EVENTS = {
  GALLERY_INTERACTED: "vehicle_detail_gallery_interacted",
  CONTACT_PANEL_VIEWED: "vehicle_detail_contact_panel_viewed",
  MOBILE_CTA_CLICKED: "vehicle_detail_mobile_cta_clicked",
  CHECKLIST_CLICKED: "vehicle_detail_checklist_clicked",
  SIMILAR_CLICKED: "vehicle_detail_similar_clicked",
  SHARE_CLICKED: "vehicle_detail_share_clicked",
};

export function buildVehicleDetailAnalyticsPayload(listing, extra = {}) {
  if (!listing) return { sourcePage: "vehicle_detail", ...extra };
  return toListingAnalyticsPayload(listing, {
    sourcePage: "vehicle_detail",
    ...extra,
  });
}

export function trackVehicleDetailEvent(eventType, listing, extra = {}) {
  trackBuyerEvent(eventType, buildVehicleDetailAnalyticsPayload(listing, extra));
}
